<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/orZzD4/media/FC-9781398465534.jpg?1685790893455" alt="This image is the cover for the book The Unknown Mysterious Cowboy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Unknown Mysterious Cowboy
      </h1>
      <p class="bookDescription body article font2">
        <p>I wasn’t really scared until they lifted me from my horse. They didn’t touch me, but they seemed to control everything. I floated from my horse, and I felt nothing. I think if they were intending to kill me they would have already. I counted nine of them, whatever they were. I could see they were moving towards the circle, and as the circle got closer I could just make out a door opening. I could see through the circle as if it were made of glass; as I was taken into the circle I could see many more of them. They were using some kind of flashing table squares. Every time the squares changed colour they used one of their arm-type things to touch the square to change it. I floated further along and could see many more of them using squares on the wall. Just past the squares on the wall I started moving sideways and ended up on a table. I still couldn’t move any part of my body. They removed my gun belt. The belt just undid itself and laid out on a side table. In the end, I had all my clothes removed. None of them touched me, it was as though my clothes had a mind of their own.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Norman Nye
      </h2>
      
      <p class="authorDescription body article">Norman was born on April 1947. He left school at the age of 15 and served 9 years in the British army. He then started a job as a European HGV driver. Norman went on to running his own business and when he sold that after many years, he was a carpenter. Then eventually, he retired. During the pandemic and having to shield due to age and health, he decided to write a book.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?bd7ca184